import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { studyTasksActions } from 'features/studyTasks';

const useStudyTasks = () => {
  const dispatch = useDispatch();
  const getStudyTasks = useCallback(({ id, offset }) => dispatch(studyTasksActions.getStudyTasks({ id, offset })), [dispatch]);
  const getStudyTask = useCallback(id => dispatch(studyTasksActions.getStudyTask(id)), [dispatch]);
  const clearLocalStudyTasks = useCallback(() => dispatch(studyTasksActions.clearLocalStudyTasks()), [dispatch]);
  const clearLocalActiveStudyTask = useCallback(() => dispatch(studyTasksActions.clearLocalActiveStudyTask()), [dispatch]);

  return {
    getStudyTasks,
    getStudyTask,
    clearLocalStudyTasks,
    clearLocalActiveStudyTask
  };
};

export default useStudyTasks;